import { LoadingIndicator } from 'components/LoadingIndicator';
import { RenderWithDelay } from 'containers/RenderWithDelay';

import { Container } from './LoadingSection.styled';

type Props = {
  delay?: number;
};

export function LoadingSection({ delay }: Props) {
  return (
    <RenderWithDelay delay={delay}>
      <Container>
        <LoadingIndicator />
      </Container>
    </RenderWithDelay>
  );
}
